module.exports = __webpack_public_path__ + "static/images/hero.f29973e2931d7909fd1dd5d71c5face4.jpg";